/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PinSvg from 'images/comment-pin.svg';
import Note from '../Note';
import styles from './Point.module.scss';
function Point({ id, pin, note, desc, component, picture, zoom, onMove, onDragEnd, bounds, preview, }) {
    const [isDraggingPin, setDraggingPin] = useState(false);
    const [isDraggingNote, setDraggingNote] = useState(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);
    const startDrag = (type, e) => {
        e.stopPropagation();
        startPosRef.current = { x: e.clientX, y: e.clientY };
        if (type === 'pin')
            setDraggingPin(true);
        else
            setDraggingNote(true);
    };
    const onDrag = useCallback((e) => {
        const dx = (e.clientX - startPosRef.current.x) / zoom;
        const dy = (e.clientY - startPosRef.current.y) / zoom;
        const newPin = isDraggingPin
            ? {
                x: clamp(pin.x + dx, 0, bounds.width),
                y: clamp(pin.y + dy, 0, bounds.height),
            }
            : pin;
        const newNote = isDraggingNote
            ? {
                x: clamp(note.x + dx, 0, bounds.width),
                y: clamp(note.y + dy, 0, bounds.height),
            }
            : note;
        onMove(newPin, newNote);
        startPosRef.current = { x: e.clientX, y: e.clientY };
    }, [bounds.height, bounds.width, isDraggingNote, isDraggingPin, pin, note, onMove, zoom]);
    const stopDrag = useCallback(() => {
        setDraggingPin(false);
        setDraggingNote(false);
        if (isDraggingPin || isDraggingNote) {
            onDragEnd(pin, note);
        }
    }, [pin, note, isDraggingPin, isDraggingNote, setDraggingPin, setDraggingNote, onDragEnd]);
    useEffect(() => {
        if (isDraggingPin || isDraggingNote) {
            document.addEventListener('mousemove', onDrag);
            document.addEventListener('mouseup', stopDrag);
        }
        return () => {
            document.removeEventListener('mousemove', onDrag);
            document.removeEventListener('mouseup', stopDrag);
        };
    }, [isDraggingPin, isDraggingNote, onDrag, stopDrag]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.pin, "data-draggable": true, style: { left: pin.x * zoom, top: pin.y * zoom }, onMouseDown: (e) => {
                e.stopPropagation();
                startDrag('pin', e);
            }, onClick: (e) => e.stopPropagation() },
            React.createElement(PinSvg, null)),
        React.createElement(Note, { disabled: preview, id: id, note: desc, picture: picture, component: component, style: { left: note.x * zoom, top: note.y * zoom }, onMouseDown: (e) => {
                e.stopPropagation();
                startDrag('note', e);
            }, onClick: (e) => e.stopPropagation() }),
        React.createElement("svg", { className: styles.line },
            React.createElement("line", { x1: pin.x * zoom, y1: pin.y * zoom, x2: note.x * zoom, y2: note.y * zoom, stroke: "black" }))));
}
export default Point;
